import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function NextGenSunscreensUseCase() {
  return (
    <>
    <section
      id="next-gen-sunscreens"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">
        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Next-Gen Sunscreens with Safer UV Filters
          </h1>
          <p className="text-slate-300 space-y-2">
            Conventional UV filters like PBSA and DPDT absorb harmful radiation effectively, but re-emit it via high-energy fluorescence — potentially increasing phototoxicity. In a recent study, Stavros and coworkers<sup>[1]</sup> demonstrated that troxerutin can act as an effective quencher, significantly reducing fluorescence lifetimes through FRET or Dexter energy transfer.
            <br /><br />
            These findings open the door to sunscreen formulations that not only block UV, but also safely dissipate that energy without re-emission — a critical advancement in skincare safety.
          </p>
        </div>

        {/* How Apoello helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Screen a large database of UV-absorbing molecules and filter by spectral overlap with UVA/UVB ranges.
    </li>
    <li>
      Predict excited-state properties, including oscillator strength and vertical excitation energies.
    </li>
    <li>
      Assess solubility and flag candidates with potential toxicity concerns.
    </li>
    <li>
      Identify photostable scaffolds and explore novel structures for enhanced broadband protection.
    </li>
  </ul>
</div>

        {/* Why it matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why it matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Safer sunscreens are vital for skin health and environmental sustainability. Computational screening enables faster, smarter design of UV-active molecules that don’t emit harmful by-products.
          </p>
        </div>

        {/* References */}
        <div className="space-y-4 pt-10">
          <h2 className="text-2xl font-semibold text-orange-300">
            References
          </h2>

          <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
            <li>
              Dalton, J.; Rodrigues, N. D. N.; Berndt, D.; Stavros, V. G. <i>Evaluating the Fluorescence Quenching of Troxerutin for Commercial UV Sunscreen Filters</i>, <i>ACS Phys. Chem. Au</i> <b>2024</b>, 4 (6), 750–760. {" "}
              <a
                href="https://doi.org/10.1021/acsphyschemau.4c00070"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F89B3F] underline"
              >
                Link ↗
              </a>
            </li>
          </ol>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>
      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}